import React from 'react'
import { useMediaQueries } from '../../usecontext/UseProvider';
import { Box, Typography } from '@mui/material';
import banner from '../../assets/product/productbanner.png';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
const ProductStartSection = () => {
  const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();


  return (
    <Box
      sx={{
        bgcolor: '#f5f5f5',
        height: '100%',
        position: 'relative',
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 2, height: { sm: '100%', xs: '200px' }, }} >
        <Box sx={{
          position: 'absolute',
          top: 0,
          height: '100%',
          width: '100%',
          backgroundColor: '#00000066',
        }}></Box>
        <img src={banner} alt='banner' className='w-100 h-100' />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2, // Ensure it stays above other content
            width: { sm: 'auto', xs: '100%' },
            px: 3
          }}
        >
          <Typography
            data-aos="fade-up"
            variant={isMediumScreen ? 'h6' : isLargeScreen ? 'h5' : 'h4'}
            sx={{
              color: '#fff',
              textAlign: 'center',
              fontWeight: 700,
              mb: 1
            }}
          >
            Shop
          </Typography>
          <Typography
            data-aos="fade-up"
            sx={{
              color: '#fff',
              textAlign: 'center',
              fontSize: isLargeScreen ? '16px' : '20px',
              lineHeight: isLargeScreen ? 'unset' : '36px',
              display: isSmallScreen ? 'none' : 'block',
            }}
          >
            Find swings that make every room more attractive.
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default ProductStartSection;